module.exports = __webpack_public_path__ + "img/exclamation-circle-icon.1000e238.svg";